import type { LinkProps } from 'react-aria-components/Link';

/**
 * React Aria maps a `href` prop that is present but undefined to an empty
 * `href` attribute, which React then reports as invalid. Spread the result of
 * this instead of passing `href` directly so the prop is left out entirely.
 */
export function linkHrefProps(href: LinkProps['href']) {
  return href === undefined ? {} : { href };
}
